module.exports = __webpack_public_path__ + "img/52d7526.jpg";